<template>
  <v-layout align-start>
    <v-flex>
      <div class="pub-page">

        <div class="pub-header">
          <div>
            <h1 class="pub-title">Secciones Públicas</h1>
            <p class="pub-subtitle">Activá o desactivá páginas y secciones visibles en el sitio</p>
          </div>
        </div>

        <v-tabs v-model="tab" color="deep-purple" background-color="transparent" class="mb-6">
          <v-tab>
            <v-icon left small>web</v-icon>
            Páginas del Sitio
          </v-tab>
          <v-tab>
            <v-icon left small>home</v-icon>
            Portada
          </v-tab>
        </v-tabs>

        <!-- Loading -->
        <div v-if="loading" class="text-center pa-10">
          <v-progress-circular indeterminate color="deep-purple"></v-progress-circular>
          <p class="mt-3 grey--text">Cargando...</p>
        </div>

        <v-tabs-items v-else v-model="tab">
          <!-- TAB: Páginas del Sitio -->
          <v-tab-item>
            <div class="pub-grid">
              <div
                v-for="s in publicSections"
                :key="s._id"
                class="pub-card"
                :class="s.enabled ? 'pub-card--on' : 'pub-card--off'"
              >
                <div class="pub-card-icon">
                  <v-icon :color="s.enabled ? 'deep-purple lighten-2' : 'grey'">{{ pageIcon(s.key) }}</v-icon>
                </div>
                <div class="pub-card-body">
                  <div class="pub-card-label">{{ s.label }}</div>
                  <div class="pub-card-key">{{ pageUrl(s.key) }}</div>
                </div>
                <div class="pub-card-switch">
                  <v-switch
                    :input-value="s.enabled"
                    color="deep-purple"
                    hide-details
                    dense
                    :loading="toggling === s._id"
                    @change="toggle(s)"
                  ></v-switch>
                  <span class="pub-card-status" :class="s.enabled ? 'status--on' : 'status--off'">
                    {{ s.enabled ? 'Activa' : 'Oculta' }}
                  </span>
                </div>
              </div>
            </div>
          </v-tab-item>

          <!-- TAB: Portada -->
          <v-tab-item>
            <v-alert type="info" outlined dense class="mb-5" style="font-size:0.87rem">
              Estas secciones aparecen en la página principal del sitio. Desactivarlas las oculta de la portada.
            </v-alert>
            <div class="pub-grid">
              <div
                v-for="s in homeSections"
                :key="s._id"
                class="pub-card"
                :class="s.enabled ? 'pub-card--on' : 'pub-card--off'"
              >
                <div class="pub-card-icon">
                  <v-icon :color="s.enabled ? 'deep-purple lighten-2' : 'grey'">{{ homeIcon(s.key) }}</v-icon>
                </div>
                <div class="pub-card-body">
                  <div class="pub-card-label">{{ s.label }}</div>
                  <div class="pub-card-key">portada &rsaquo; {{ s.label }}</div>
                </div>
                <div class="pub-card-switch">
                  <v-switch
                    :input-value="s.enabled"
                    color="deep-purple"
                    hide-details
                    dense
                    :loading="toggling === s._id"
                    @change="toggle(s)"
                  ></v-switch>
                  <span class="pub-card-status" :class="s.enabled ? 'status--on' : 'status--off'">
                    {{ s.enabled ? 'Activa' : 'Oculta' }}
                  </span>
                </div>
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>

      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  name: "PublicSections",
  data() {
    return {
      tab: 0,
      loading: true,
      toggling: null,
      sections: [],
    };
  },
  computed: {
    publicSections() {
      return this.sections.filter(s => s.type === "public");
    },
    homeSections() {
      return this.sections.filter(s => s.type === "home");
    },
  },
  async created() {
    await this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get("section-settings", { headers: { Authorization: token } });
        this.sections = res.data || [];
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    async toggle(section) {
      this.toggling = section._id;
      try {
        const token = localStorage.getItem("token");
        await axios.patch(`section-settings/${section._id}/toggle`, {}, { headers: { Authorization: token } });
        section.enabled = !section.enabled;
      } catch (e) {
        console.error(e);
      } finally {
        this.toggling = null;
      }
    },
    pageIcon(key) {
      const map = {
        "page-actividades":  "event",
        "page-blog":         "article",
        "page-login":        "login",
        "page-contacto":     "contact_support",
        "page-donar":        "volunteer_activism",
        "page-educacion":    "school",
        "page-faq":          "help_outline",
        "page-ferias":       "store",
        "page-principios":   "gavel",
        "page-adhesiones":   "person_add",
        "page-tienda":       "shopping_cart",
        // No sigue el prefijo "page-" (ver el comentario de la clave en
        // lla-api/src/services/sectionSetting.service.js): es EL interruptor maestro de toda
        // Cumbre 11D, portada, header, /cumbre11d y la sección del portal incluidos.
        "evento-cumbre11d": "celebration",
      };
      return map[key] || "link";
    },
    pageUrl(key) {
      if (key === "evento-cumbre11d") return "/cumbre11d y portada";
      return "/" + key.replace("page-", "");
    },
    homeIcon(key) {
      const map = {
        "home-instagram":     "photo_camera",
        "home-faq":           "help_outline",
        "home-ferias":        "store",
        "home-asociaciones":  "handshake",
        "home-pilares":       "auto_awesome",
        "home-actividades":   "event",
        "home-militancia":    "place",
        "home-sedes":         "business",
        "home-noticias":      "newspaper",
        "home-cta":           "campaign",
        "home-videos":        "play_circle",
      };
      return map[key] || "view_module";
    },
  },
};
</script>

<style scoped>
.pub-page {
  padding: 24px;
  max-width: 900px;
  margin: 0 auto;
}
.pub-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 20px;
}
.pub-title {
  font-size: 1.7rem;
  font-weight: 700;
  margin-bottom: 4px;
}
.pub-subtitle {
  color: #888;
  font-size: 0.95rem;
}
.pub-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 12px;
}
.pub-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  border-radius: 12px;
  border: 1px solid rgba(255,255,255,0.08);
  background: rgba(255,255,255,0.03);
  transition: box-shadow 0.2s, border-color 0.2s;
}
.pub-card--on {
  border-color: rgba(149, 117, 205, 0.35);
  background: rgba(103, 58, 183, 0.07);
}
.pub-card--off {
  opacity: 0.55;
}
.pub-card:hover {
  box-shadow: 0 3px 12px rgba(0,0,0,0.2);
}
.pub-card-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(255,255,255,0.06);
  display: flex;
  align-items: center;
  justify-content: center;
}
.pub-card-body {
  flex: 1;
  min-width: 0;
}
.pub-card-label {
  font-weight: 600;
  font-size: 0.95rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.pub-card-key {
  font-size: 0.73rem;
  color: #888;
  margin-top: 2px;
}
.pub-card-switch {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
}
.pub-card-status {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-top: 2px;
}
.status--on  { color: #7c4dff; }
.status--off { color: #777; }

/* Light theme */
.theme--light .pub-card {
  background: #fff;
  border-color: #e8e8e8;
}
.theme--light .pub-card--on {
  border-color: #b39ddb;
  background: #f3eeff;
}
.theme--light .pub-card-icon {
  background: #f0f0f0;
}
</style>
